import type { SVGProps } from 'react';

const SvgAiMetadata = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M5.5 10c.15 0 .26-.12.26-.26 0-2.41 1.56-3.97 3.97-3.97.15 0 .26-.12.26-.26s-.12-.26-.26-.26c-2.41 0-3.97-1.56-3.97-3.97 0-.15-.12-.26-.26-.26s-.26.12-.26.26c0 2.41-1.56 3.97-3.97 3.97-.15 0-.26.12-.26.26s.12.26.26.26c2.41 0 3.97 1.56 3.97 3.97 0 .15.12.26.26.26m17.24 8.24c-2.41 0-3.97-1.56-3.97-3.97 0-.15-.12-.26-.26-.26s-.26.12-.26.26c0 2.41-1.56 3.97-3.97 3.97-.15 0-.26.12-.26.26s.12.26.26.26c2.41 0 3.97 1.56 3.97 3.97 0 .15.12.26.26.26s.26-.12.26-.26c0-2.41 1.56-3.97 3.97-3.97.15 0 .26-.12.26-.26s-.12-.26-.26-.26M13 5h3c.55 0 1 .45 1 1v5c0 .55.45 1 1 1s1-.45 1-1V6c0-1.65-1.35-3-3-3h-3c-.55 0-1 .45-1 1s.45 1 1 1m-2 14H8c-.55 0-1-.45-1-1v-5c0-.55-.45-1-1-1s-1 .45-1 1v5c0 1.65 1.35 3 3 3h3c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M14 7h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1m0 4h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1m-2 4h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgAiMetadata;
